import { useTranslation } from "react-i18next";
import styles from "./ExtraTip.module.scss";
// import { useState } from "react";
// import DropDown from "../../../DropDown/DropDown";
import TransparentTile from "../../../TransparentTile/TransparentTile";
import { useVenuesDataStore } from "@/store/useVenuesDataStore";

function ExtraTip() {
  const { t } = useTranslation();
  // const [showPayments, setShowPayments] = useState(false);
  // const toggleShowPayments = () => setShowPayments(!showPayments);
  const { selectedAmount, remainingAmount } = useVenuesDataStore();

  return (
    <div className={styles.extraTipContent}>
      <p className={`title-large ${styles.extraTipTitle}`}>
        {t("gradientDrawer.extraTip.header.title")}
      </p>
      <div className={styles.extraTipPaymentsDetailsContainer}>
        <div className={styles.extraTipPaymentDetailsDesctiptionContainer}>
          <p className={`body-medium ${styles.extraTipSummaryTitle}`}>
            {t("gradientDrawer.extraTip.summary.title")}
          </p>
          {/* <DropDown
            text={t("gradientDrawer.extraTip.summary.showPayments")}
            fontSize="body-medium"
            toggledIcon="las la-angle-up"
            icon="las la-angle-down"
            onClick={toggleShowPayments}
            isToggled={showPayments}
            iconFontSize="icon-small"
          /> */}
        </div>
        <p className={`title-large ${styles.extraTipSummaryPrice}`}>
          {(remainingAmount / 100).toFixed(2)} zł
        </p>
      </div>
      {/* {showPayments && (
        <div className={styles.extraTipPaymentsDetails}>
          <p className={`body-medium ${styles.extraTipPaymentsDetailsTitle}`}>
            {t("gradientDrawer.extraTip.summary.total")}
          </p>
          <p className={`body-medium ${styles.extraTipPaymentsDetailsPrice}`}>
            $ 26.00{" "}
          </p>
        </div>
      )} */}
      <TransparentTile>
        <div className={styles.extraTipEnteredAmountContainer}>
          <p className={`body-medium ${styles.extraTipEnteredAmountTitle}`}>
            {t("gradientDrawer.extraTip.summary.amountYouEntered")}
          </p>
          <p className={`headline-large ${styles.extraTipEnteredAmountPrice}`}>
            {selectedAmount.toFixed(2)} zł
          </p>
        </div>
      </TransparentTile>
    </div>
  );
}
export default ExtraTip;
